import { Flex } from "@chakra-ui/react";
import { Outlet } from "react-router";

import { useSlugParam } from "@/common/hooks/useParam";
import { FeatureConfigs as FeatureConfigsComponent } from "@/feature/components/FeatureConfigs";
import { SetupInstructions } from "@/feature/components/SetupInstructions";

import FeatureSideBarWrapper from "../components/FeatureSidebarWrapper";

export default function FeatureConfigs() {
  const { featureId } = useSlugParam("feature");

  return (
    <FeatureSideBarWrapper>
      <Flex direction="column" flexGrow={1} px={6} py={4} w="full">
        <SetupInstructions featureId={featureId} usecase="config" />
        <FeatureConfigsComponent />
        <Outlet />
      </Flex>
    </FeatureSideBarWrapper>
  );
}
